module.exports = __webpack_public_path__ + "static/media/monsido.f5682854.jpg";